// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"60":"35b31b90","239":"f2fac5b9","293":"7dca76de","455":"d8a4e1c2","977":"b4eaaac2"}[chunkId] + ".chunk.js";
};